import { isPending } from './isPending'
import { isPhysical } from './isPhysical'
import { BankingCard } from './types'

export const canActivateCard = (card: BankingCard | null | undefined): boolean => {
  return card?._policies?.activate?.can === true && isPending(card) && isPhysical(card)
}
